import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1033.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1033.000000) scale(0.100000,-0.100000)">

<path d="M7770 7190 c-8 -5 -12 -11 -10 -14 3 -2 14 2 24 10 22 15 10 19 -14
4z"/>
<path d="M1747 5518 c-113 -150 -204 -276 -201 -280 2 -4 632 -7 1398 -7 1002
1 1409 -2 1449 -11 128 -26 206 -108 207 -218 0 -68 -18 -109 -65 -151 -91
-80 -156 -90 -564 -91 -275 0 -332 -2 -328 -14 3 -7 205 -250 449 -539 l443
-527 438 0 439 0 -42 50 c-22 27 -171 181 -330 342 -159 161 -288 293 -287
294 1 1 27 9 57 19 173 55 322 181 397 335 69 142 88 292 58 464 -51 290 -317
505 -707 571 -186 32 -323 35 -1459 35 l-1146 0 -206 -272z"/>
<path d="M8297 5476 c-136 -38 -234 -185 -212 -319 40 -237 323 -330 491 -162
65 65 89 129 82 224 -6 77 -30 131 -85 183 -72 70 -184 100 -276 74z"/>
<path d="M2863 5078 c-60 -45 -254 -197 -433 -338 -179 -141 -397 -312 -485
-380 -218 -171 -259 -211 -297 -288 -61 -124 -32 -264 69 -332 97 -63 22 -60
1420 -60 700 0 1273 3 1273 8 0 7 -52 70 -300 362 l-155 182 -614 -6 -613 -6
143 107 c79 59 284 218 454 353 171 135 372 295 448 355 75 60 137 112 137
117 0 4 -211 8 -470 8 l-469 0 -108 -82z"/>
<path d="M7480 4721 l0 -68 -39 19 c-54 26 -101 17 -141 -28 -26 -30 -30 -43
-30 -89 0 -49 4 -60 34 -93 31 -33 40 -37 84 -37 34 0 56 6 70 18 19 17 20 17
25 -3 3 -14 13 -20 31 -20 l26 0 0 185 0 185 -30 0 -30 0 0 -69z m-17 -113
c40 -48 3 -138 -58 -138 -56 0 -94 76 -64 131 22 42 89 46 122 7z"/>
<path d="M5550 4740 l0 -29 96 -3 95 -3 -101 -120 c-135 -161 -136 -159 48
-163 l142 -3 0 30 0 30 -100 3 -100 3 100 117 c71 82 100 124 100 142 l0 26
-140 0 -140 0 0 -30z"/>
<path d="M7752 4599 l3 -174 95 0 c81 0 101 4 135 23 58 33 78 67 83 133 5 72
-17 121 -71 157 -35 24 -52 27 -144 30 l-103 4 2 -173z m192 101 c33 -12 66
-66 66 -105 0 -39 -33 -93 -66 -105 -14 -6 -48 -10 -75 -10 l-49 0 0 115 0
115 49 0 c27 0 61 -4 75 -10z"/>
<path d="M8427 4744 c-4 -4 -7 -20 -7 -35 0 -15 -7 -29 -15 -33 -8 -3 -15 -15
-15 -26 0 -11 7 -20 15 -20 12 0 15 -14 15 -70 0 -112 30 -150 106 -135 29 5
35 10 32 28 -2 17 -10 22 -33 22 l-30 0 -3 78 -3 77 36 0 c32 0 36 3 33 23 -2
17 -11 23 -35 25 -28 3 -32 7 -35 35 -2 26 -8 33 -28 35 -14 2 -29 0 -33 -4z"/>
<path d="M5953 4679 c-52 -15 -83 -61 -83 -124 0 -43 5 -60 26 -84 50 -60 151
-65 205 -12 52 53 48 159 -9 199 -33 24 -97 34 -139 21z m78 -49 c5 0 18 -9
29 -20 45 -45 8 -140 -55 -140 -56 0 -94 76 -64 131 12 23 47 40 67 33 8 -2
18 -4 23 -4z"/>
<path d="M6264 4680 c-117 -36 -115 -212 4 -251 119 -39 219 74 166 187 -26
54 -104 83 -170 64z m104 -76 c35 -40 23 -101 -25 -123 -35 -16 -49 -14 -78
12 -20 17 -27 32 -27 60 0 81 75 110 130 51z"/>
<path d="M6510 4554 l0 -135 28 3 c27 3 27 4 30 85 3 75 5 84 29 103 14 11 34
20 44 20 13 0 19 7 19 24 0 35 -12 38 -53 17 -34 -17 -36 -17 -40 0 -3 13 -14
19 -31 19 l-26 0 0 -136z"/>
<path d="M6763 4679 c-17 -5 -43 -23 -57 -40 -21 -25 -26 -41 -26 -86 0 -49 4
-59 33 -88 63 -63 167 -56 214 14 38 56 23 151 -29 185 -30 20 -95 27 -135 15z
m110 -71 c41 -47 3 -138 -58 -138 -56 0 -94 76 -64 131 22 42 88 45 122 7z"/>
<path d="M7075 4684 c-34 -8 -75 -26 -75 -33 1 -25 19 -31 61 -22 49 11 91 -2
97 -30 2 -14 -9 -17 -67 -21 -83 -4 -105 -20 -105 -74 0 -69 75 -105 144 -69
27 14 30 14 30 0 0 -10 10 -15 30 -15 l30 0 0 94 c0 102 -9 139 -37 155 -24
12 -83 21 -108 15z m85 -163 c0 -40 -79 -68 -108 -39 -16 16 -15 45 1 51 6 3
33 6 60 6 40 1 47 -2 47 -18z"/>
<path d="M8185 4681 c-53 -13 -67 -24 -53 -44 11 -13 20 -15 53 -7 45 10 88
-4 93 -33 3 -14 -5 -17 -53 -17 -55 0 -93 -12 -107 -34 -15 -22 -8 -83 11
-100 28 -25 83 -31 118 -12 27 14 32 14 37 1 3 -8 17 -15 31 -15 l25 0 0 101
c0 55 -5 109 -11 121 -11 21 -67 49 -96 47 -10 -1 -32 -4 -48 -8z m95 -159 c0
-47 -88 -70 -113 -30 -18 28 9 48 64 48 41 0 49 -3 49 -18z"/>
<path d="M8675 4681 c-53 -13 -67 -24 -53 -44 11 -13 20 -15 53 -7 45 10 88
-4 93 -33 3 -14 -5 -17 -53 -17 -55 0 -93 -12 -107 -34 -15 -22 -8 -83 11
-100 28 -25 83 -31 118 -12 27 14 32 14 37 1 3 -8 17 -15 31 -15 l25 0 0 101
c0 55 -5 109 -11 121 -11 21 -67 49 -96 47 -10 -1 -32 -4 -48 -8z m95 -159 c0
-47 -88 -70 -113 -30 -18 28 9 48 64 48 41 0 49 -3 49 -18z"/>
</g>
</svg>






    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
